module.exports = __webpack_public_path__ + "static/waking-vessels-4a64b9a178ef0dc2131d085711cba2d1.jpg";